/** Состояние оверлеев поверх оболочки прототипа (меню файла, диалоги, ⌘K, уведомления). */
import { useSyncExternalStore } from 'react';

export type DialogKind = 'rename' | 'move' | 'access' | 'delete' | 'trash' | 'palette' | 'conflict' | 'admission';
export interface OverlayState {
  menu: { id: string; x: number; y: number } | null;
  dialog: { kind: DialogKind; id?: string } | null;
  snack: { text: string; action?: { label: string; run: () => void } } | null;
}

let state: OverlayState = { menu: null, dialog: null, snack: null };
const listeners = new Set<() => void>();
let snackTimer: ReturnType<typeof setTimeout> | undefined;

export const overlay = {
  get: () => state,
  set(patch: Partial<OverlayState>) {
    state = { ...state, ...patch };
    listeners.forEach((l) => l());
  },
  subscribe(l: () => void) {
    listeners.add(l);
    return () => listeners.delete(l);
  },
  openMenu: (id: string, x: number, y: number) => overlay.set({ menu: { id, x, y } }),
  openDialog: (kind: DialogKind, id?: string) => overlay.set({ menu: null, dialog: { kind, id } }),
  close: () => overlay.set({ menu: null, dialog: null }),
  snack(
    text: string,
    action?: OverlayState['snack'] extends infer S ? (S extends { action?: infer A } ? A : never) : never,
  ) {
    clearTimeout(snackTimer);
    overlay.set({ snack: { text, action } });
    snackTimer = setTimeout(() => overlay.set({ snack: null }), action ? 7000 : 3500);
  },
};

export const useOverlay = () => useSyncExternalStore(overlay.subscribe, overlay.get);
